var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamePlans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 0A250.3 250.3 0 0 0 0 250c0 48.8 10.8 87.5 36 129.2a17.3 17.3 0 0 0 29.6-17.8 200 200 0 0 1-31-111.4A215.7 215.7 0 0 1 250 34.5 215.7 215.7 0 0 1 465.5 250 215.7 215.7 0 0 1 250 465.5c-60.9 0-103.3-23-128.2-42.2a17.2 17.2 0 0 0-21.2 27.1A242 242 0 0 0 250 500c137.8 0 250-112.2 250-250S387.8 0 250 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.7 369.8l148.2-65c1.4-.8 3-1.8 4.2-3 .2-.3.7-.5 1-.8 1.4-1.4 2.6-3.4 3.6-5.4v-.2l62-146.2c2.6-6.4 1.2-14-3.8-19s-12.5-6.4-19-3.7l-145 62.8-.2.3c-2 1-4 2.2-5.4 3.7-.3.2-.3.5-.5.7-1.2 1.5-2.5 3-3.2 4.5v.5L125 347c-3 6.4-1.5 14 3.7 19 3.2 3.2 7.6 5.2 12 5.2 2.3 0 4.8-.5 7-1.5zM283 258.6l-47.3-47.3 82.8-35.8-35.5 83.1zm-71.7-22.9l47.8 47.8-85 37 37.2-84.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamePlans);
export default __webpack_public_path__ + "static/media/game-plans.3d4d2513.svg";
export { ForwardRef as ReactComponent };